module.exports = __webpack_public_path__ + "src/assets/images/favicon.ico?6ed63f652a7ad59664d8c0bf35339560";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.ico
// module id = 990
// module chunks = 1